import { TOTAL_PRICE, TOTAL_PRICE_NUM } from "../mutation-types";
import { numberSpliter } from "@/utils/functions";
export default {
  [TOTAL_PRICE]: state => {
    const { cpu, ram, storage } = state;
    var result =
      cpu.value * cpu.pricePerUnit +
      ram.value * ram.pricePerUnit +
      storage.value * storage.pricePerUnit;
    return numberSpliter(result);
  },
  [TOTAL_PRICE_NUM]: state => {
    const { cpu, ram, storage } = state;
    var result =
      cpu.value * cpu.pricePerUnit +
      ram.value * ram.pricePerUnit +
      storage.value * storage.pricePerUnit;
    return result;
  }
};
